export default __webpack_public_path__ + "static/media/026-caliper.b11b021b.svg";